import React from 'react';
import { XSButton } from '../../xs/component/button/XSButton';

interface Props {
    query: any;
}

export function DownloadButton({ query }: Props) {
    const url = query.response;

    return (
        <>
            {url ? (
                <a href={url}>
                    <XSButton color={'success'}>Download</XSButton>
                </a>
            ) : (
                <XSButton onClick={() => query.run()} loading={query.isLoading} icon={'get_app'} />
            )}
        </>
    );
}
